<template>
    <div>
        <div class="office_emp_map_block">
            <ContentHeaderSectionButton :title="'Office Setup'" :icon="'fa fa-cogs'" :buttontext="'Assign New Office'"
                :action="service_assign" />
            <div class="flex justify-end mr-4 mt-2">
                <div class="col-end-7 col-span-1 ...">
                    <a class="btn-indigo" href="#" type="button" @click="service_assign(serviceinfos, 'N')"><i
                            class="fa fa-plus-circle"></i><span>Assign</span><span
                            class="hidden md:inline">&nbsp;Office</span>
                    </a>
                </div>
            </div>
            <div class="p-5 select_geo_map_block">
                <div class="bg-white rounded-md shadow overflow-x-auto">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold">
                                <th class="pb-2 pt-3 px-3 w-12">#</th>
                                <th class="pb-2 pt-3 px-3">Office Layer</th>
                                <th class="pb-2 pt-3 px-3">Location Name</th>
                                <th class="pb-2 pt-3 px-3 items-center text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="config in officeMapConfigs" :key="config.key">
                                <tr v-if="config.list.length > 0">
                                    <td :colspan="4" class="bg-gray-200 font-semibold px-3 py-2 border-t text-left">
                                        {{ config.label }}
                                    </td>
                                </tr>
                                <tr v-for="(item, idx) in config.list" :key="item.id"
                                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                                    <td class="pb-2 pt-3 px-3 border-t">{{ idx + 1 }}</td>
                                    <td class="pb-2 pt-3 px-3 border-t">{{ item[config.layerField]?.office_layer_name }}
                                    </td>
                                    <td class="pb-2 pt-3 px-3 border-t">{{ config.locationName(item) }}</td>
                                    <td class="pb-2 pt-3 px-3 border-t">
                                        <div class="flex items-center px-2" :class="config.actionJustify">
                                            <div class="flex items-center px-4" tabindex="0"
                                                @click="service_assign(serviceinfos, config.type, item.id)">
                                                <i class="fa fa-edit text-blue-600 hover:text-blue-800"></i>
                                            </div>
                                            <div class="flex items-center px-4" tabindex="0"
                                                @click="delete_service_map(item.id, config.type)">
                                                <i class="fa fa-trash text-red-600 hover:text-red-800"></i>
                                            </div>
                                            <div v-if="config.copyable" class="flex items-center px-4" tabindex="0"
                                                @click="copy_service_map(item.id, config.type)">
                                                <i
                                                    class="fa fa-copy cursor-pointer text-green-600 hover:text-green-800"></i>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <template v-if="assign_on">
        <!-- <div class="black_overlay" @click="remove_assign"></div> -->
        <div :class="['assign_setup_block', { active: assign_on }]">
            <div class="flex items-center justify-center close_btn_assign" @click="remove_assign"><i
                    class="fa fa-times"></i></div>
            <div class="assign_info">Service Name : {{ sel_service_name }}</div>
            <div class="grid grid-flow-col gap-3">
                <div>
                    <officeAssign :servicedata="servicedata" :paymentdata="payment_data"
                        :service_name="sel_service_name" :service_id="service_id" :sel_type="ser_type" :sel_id="ser_id"
                        :employee_geo_map="geodata" :others="othersdata" :assign_on="assign_on"
                        @remove_assign="remove_assign" />
                </div>

            </div>
        </div>
    </template>
</template>
<script>
    import axios from "axios"
    import { ref, toRefs, onMounted, watch } from "vue"
    import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
    import ContentHeaderSectionButton from "@/Shared/ContentHeaderSectionButton"
    import FloatingActionBtn from "@/Shared/Buttons/FloatingActionBtn"
    import SelectInputFunction from '@/Shared/SelectInputFunction'
    import SelectInput from '@/Shared/SelectInput'
    import officeAssign from './officeAssign'
    export default {
        name: "OfficeLayerBlock",
        props: {
            service_id: Number,
            service_name: String,
            payment_data: Object,
        },
        components: {
            ContentHeaderSectionButton,
            FloatingActionBtn,
            Head,
            Link,
            SelectInputFunction,
            SelectInput,
            officeAssign
        },
        setup(props, { emit }) {
            // Config for each office map type to simplify table rendering
            const officeMapConfigs = [
                {
                    key: 'ministry',
                    label: 'Ministry',
                    get list() { return serviceinfos.value?.service_ministry_map || [] },
                    type: 'M',
                    layerField: 'officelayer',
                    locationName: (item) => item.ministry?.ministry_name,
                    copyable: true,
                    actionJustify: 'justify-center',
                },
                {
                    key: 'region',
                    label: 'Region',
                    get list() { return serviceinfos.value?.service_region_map || [] },
                    type: 'R',
                    layerField: 'officelayer',
                    locationName: (item) => item.region?.region_name,
                    copyable: true,
                    actionJustify: 'justify-center',
                },
                {
                    key: 'province',
                    label: 'Province',
                    get list() { return serviceinfos.value?.service_province_map || [] },
                    type: 'P',
                    layerField: 'officelayer',
                    locationName: (item) => item.provience?.provience_name,
                    copyable: true,
                    actionJustify: 'justify-center',
                },
                {
                    key: 'municipality',
                    label: 'Municipality',
                    get list() { return serviceinfos.value?.service_municipality_map || [] },
                    type: 'MU',
                    layerField: 'officelayer',
                    locationName: (item) => item.municipality?.municipality_name,
                    copyable: true,
                    actionJustify: 'justify-center',
                },
                {
                    key: 'barangay',
                    label: 'Barangay',
                    get list() { return serviceinfos.value?.service_barangay_map || [] },
                    type: 'B',
                    layerField: 'officelayer',
                    locationName: (item) => item.barangay?.barangay_name,
                    copyable: true,
                    actionJustify: 'justify-center',
                },
            ]
            const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)
            const { service_id, service_name, payment_data } = toRefs(props)
            const preloader = ref(false)
            const serviceinfos = ref({})
            const paymentdata = ref({})
            const message = ref('');
            const sel_service_name = ref('');
            const assign_on = ref(false)
            const ser_type = ref('')
            const ser_id = ref('')
            const servicedata = ref({})
            const geodata = ref({
                ministry_id: null,
                region_id: 1,
                province_id: null,
                municipality_id: null,
                barangay_id: null,
                office_layer_id: null,
                office_id: null,

                fixed_amount: 0,
                pre_amount: null,
                amount: null,
                account_info: null
            })
            const othersdata = ref({})

            const remove_assign = () => {
                loaddata(service_id.value);
                assign_on.value = false
            }
            const loaddata = (id) => {
                preloader.value = true
                let data = { id: id }
                axios.post(`/${backendPrefix.value}/serviceinfos/getservicemap`, data)
                    .then(function (response) {
                        if (response.data.status == true) {
                            serviceinfos.value = response.data.data;
                        }
                        preloader.value = false
                    });
            }
            onMounted(() => {
                loaddata(service_id.value);
            })
            const service_assign = async (serviceinfos, type, id = null) => {
                ser_type.value = type
                ser_id.value = id
                servicedata.value = serviceinfos
                sel_service_name.value = service_name.value
                paymentdata.value = payment_data
                if (type != '' && id > 0) {
                    console.log('Selected type:', type, 'ID:', id);
                    let data = {
                        id: id,
                        sel_type: type,
                    }
                    await axios.post(`/${backendPrefix.value}/service-map/selected-data`, data)
                        .then(function (response) {
                            geodata.value = response.data.data.geos
                            othersdata.value = response.data.data
                            if (response.data.data.geos != '') {
                                assign_on.value = true
                            }
                        });
                } else {
                    geodata.value = {}
                    othersdata.value = {}
                    console.log('No type or ID selected, opening assign form');
                    assign_on.value = true
                }
            }
            const delete_service_map = (id, type) => {
                if (!confirm('Do you really want to delete this?')) return;
                const urlMap = {
                    M: `/${backendPrefix.value}/service-map/delete-ministry-map`,
                    R: `/${backendPrefix.value}/service-map/delete-region-map`,
                    P: `/${backendPrefix.value}/service-map/delete-province-map`,
                    MU: `/${backendPrefix.value}/service-map/delete-municipality-map`,
                    B: `/${backendPrefix.value}/service-map/delete-barangay-map`,
                };
                const url = urlMap[type];
                if (!url) return;
                axios.post(url, { id })
                    .then(async (response) => {
                        message.value = response.data.message;
                        loaddata(service_id.value);
                        preloader.value = false;
                    })
                    .catch(() => {
                        preloader.value = false;
                    });
            }
            const copy_service_map = (id, type) => {
                if (confirm('Do you really want to copy this?')) {
                    let data = {
                        id: id,
                        sel_type: type,
                    }
                    const url = `/${backendPrefix.value}/service-map/copy-service-map`;
                    if (url != '') {
                        axios.post(url, data)
                            .then(async (response) => {
                                console.log(response);
                                message.value = response.data.message
                                loaddata(service_id.value);
                                preloader.value = false
                            }).catch(error => {
                                console.log(error);
                                preloader.value = false
                            });
                    }
                }

            }
            const remove_msg = () => {
                message.value = ''
            }
            watch(() => assign_on.value, () => {
                if (assign_on.value == false) {
                    loaddata(service_id.value);
                }

            }, { deep: true })


            return {
                preloader,
                backendPrefix,
                service_id,
                sel_service_name,
                loaddata,
                serviceinfos,
                service_assign,
                remove_assign,
                assign_on,
                ser_type,
                ser_id,
                servicedata,
                delete_service_map,
                remove_msg,
                message,
                geodata,
                othersdata,
                payment_data,
                paymentdata,
                copy_service_map,
                officeMapConfigs
            }
        },
        created: function () {
        }

    }

</script>
<style lang="scss" scoped>
    $checkbox_size: 20;

    .office_emp_map_block {
        display: block;
        position: relative;

        // padding-bottom: 50px;
        .select_geo_map_block {
            display: block;

            :deep(.action_btn) {
                right: 20px;
                bottom: 20px;
            }

            &>div {
                display: flex;
                gap: 10px;
                align-items: center;

                .checkbox_block {
                    display: inline-block;
                    width: #{$checkbox_size}px;
                    height: #{$checkbox_size}px;
                    line-height: #{$checkbox_size}px;
                    text-align: center;
                    font-size: 10px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    cursor: pointer;
                    transition: all 0.4s;

                    &>i {
                        display: none;
                        opacity: 0;
                        line-height: #{$checkbox_size}px;
                        transition: all 0.4s;
                    }

                    &:hover {
                        color: #ccc;
                        border-color: #ccc;

                        &>i.checked {
                            display: block;
                            opacity: 1;
                        }
                    }

                    &.active {
                        color: #006699;
                        border-color: #006699;

                        &>i.checked {
                            display: block;
                            opacity: 1;
                        }

                        &:hover {
                            color: #CD0000;
                            border-color: #CD0000;

                            &>i.checked {
                                display: none;
                                opacity: 0
                            }

                            &>i.remove {
                                display: block;
                                opacity: 1;
                            }
                        }
                    }
                }

                .info_block {
                    &.active {
                        font-weight: 600;
                    }
                }
            }
        }
    }

    .assign_setup_block {
        position: fixed;
        min-width: 1200px;
        background-color: #fff;
        padding: 25px;
        right: 0;
        top: 0;
        height: 100%;
        overflow-y: auto;
        z-index: 11000;
        transition: all 0.4s;

        &.active {
            right: 0;
        }

        &>.assign_info {
            font-size: 14px;
            font-weight: 600;
            height: 46px;
            color: #666;
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            border-bottom: 1px solid #ddd;
            justify-content: center;
            border-radius: 15px;
            position: absolute;
            width: calc(100% - 70px);
            left: 40px;
            top: 0;
        }

        &>.close_btn_assign {
            position: sticky;
            margin-left: -25px;
            margin-top: -25px;
            top: -25px;
            width: 40px;
            height: 47px;
            background-color: #00000080;
            color: #fff;
            cursor: pointer;
            border-radius: 0 0px 15px 0;
            z-index: 5;
        }
    }

    .organogram_btn {
        background-color: #152b74;
        color: #fff;
        border-radius: 25px;
        cursor: pointer;
        transition: all 0.4s;
        height: 22px;
        margin: 10px;
        font-size: 10px;

        &:hover {
            background-color: #2d6f90;
        }
    }

    i.fa.fa-edit {
        cursor: pointer;
    }

    i.fa.fa-trash {
        cursor: pointer;
    }
</style>
